import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { LangSwitch } from "@/i18n";
import { useAuth, login } from "@/context/AuthContext";
import { useT } from "@/i18n";

const LINKS = [
  ["/grader", "Listing Grader"], ["/house-rules", "House Rules"], ["/templates", "Templates"],
  ["/guides", "Guides"], ["/pricing", "Pricing"],
];

export const Navbar = () => {
  const { user } = useAuth();
  const { t } = useT();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#F4E9D8] border-b border-[#E2DCD0] no-print" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link"><Logo /></Link>
        <nav className="hidden xl:flex items-center gap-6">
          {LINKS.map(([to, label]) => (
            <NavLink key={to} to={to} data-testid={`nav-${to.slice(1)}-link`}
              className={({ isActive }) => `whitespace-nowrap text-sm font-medium transition-colors duration-200 hover:text-[#E36414] ${isActive ? "text-[#E36414]" : "text-[#0F4C5C]"}`}>
              {t(label)}
            </NavLink>
          ))}
        </nav>
        <div className="hidden xl:flex items-center gap-3">
          <LangSwitch />
          {user ? (
            <Link to="/app" className="btn-teal text-sm !py-2" data-testid="nav-open-app-btn">{t("Open app")}</Link>
          ) : (
            <>
              <button onClick={login} className="text-sm font-medium text-[#0F4C5C] hover:text-[#E36414] transition-colors" data-testid="nav-login-btn">{t("Sign in")}</button>
              <Link to="/grader" className="btn-coral text-sm !py-2 whitespace-nowrap" data-testid="nav-cta-grader-btn">{t("Grade my listing")}</Link>
            </>
          )}
        </div>
        <button className="xl:hidden text-[#0F4C5C]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>
      {open && (
        <div className="xl:hidden px-6 pb-6 flex flex-col gap-4 bg-[#F4E9D8]" data-testid="nav-mobile-menu">
          <LangSwitch testid="mobile-lang-switch" />
          {LINKS.map(([to, label]) => <Link key={to} to={to} onClick={() => setOpen(false)} className="text-[#0F4C5C] font-medium">{t(label)}</Link>)}
          {user ? <Link to="/app" className="btn-teal w-fit">{t("Open app")}</Link> : <button onClick={login} className="btn-coral w-fit">{t("Sign in with Google")}</button>}
        </div>
      )}
    </header>
  );
};
